/* unplugin-vue-components disabled */import script from "./CompetitionSignUpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionSignUpDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionSignUpDialog.vue?vue&type=style&index=0&id=71b251c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b251c9"]])

export default __exports__